export default "__VITE_ASSET__CcHxZh_l__"